<template>
  <div id="app" @contextmenu="rightDian">
    <HelloWorld :scrollHeight="scrollHeight" />
  </div>
</template>

<script>
  import HelloWorld from "@/components/HelloWorld.vue";
  export default {
    components: { HelloWorld },
    name: "App",
    data() {
      return {
        scrollHeight: 0,
      }
    },
    mounted() {
      // document.addEventListener("keydown", function (e) {
      //   if (e.key == "F12") {
      //     e.preventDefault(); // 如果按下键F12,阻止事件
      //   }
      // });
      (function () {
        console.log(11111111111)
        // 页面一加载就要知道页面宽度计算
        var setFont = function () {
          // 因为要定义变量可能和别的变量相互冲突，污染，所有用自调用函数
          var html = document.documentElement; // 获取html
          // 宽高比
          const widthToHeight = 1920 / 1080;
          // 获取宽度
          var width = html.clientWidth;
          // 计算高度
          const height = width / widthToHeight;
          //设置body的高度 
          // document.getElementsByTagName("body")[0].style.height = height + "px";
          // document.getElementsByTagName("body")[0].style.border = '2px solid';

          // 设计稿1920   设计稿对应的HTML fontsize 100

          const rate = 1920 / 100

          // 设置html的基准值
          var fontSize = width / rate + "px";

          // 根据当当前屏幕宽度动态修改html 根元素的fontsize
          html.style.fontSize = fontSize;
        };
        setFont();
        // 2、页面改变的时候也需要设置
        // 尺寸改变事件
        window.addEventListener("resize", function () {
          setFont();
        });
      })();
      // 滚动条的获取
      window.addEventListener('scroll', this.handleScrollx, true)
    },
    methods: {
      handleScrollx() {
        this.scrollHeight = window.pageYOffset;
        // console.log('距离顶部高度', this.$refs.obtain.getBoundingClientRect().top)
      },
      rightDian() {
        event.returnValue = false;
      },
    }
  };
</script>

<style>
  * {
    margin: 0;
    padding: 0;
    list-style-type: none;
    font-family: Microsoft YaHei;
    font-size: .16rem;
  }

  div {
    color: #000;
  }

  #app {
    background: #fff;
  }

  .el-dialog__body {
    padding: .05rem .2rem !important;
  }

  .el-checkbox__inner {
    width: .2rem;
    height: .2rem;
  }

  .el-checkbox__inner::after {
    width: .05rem;
    height: .12rem;
    left: .07rem;
  }

  .el-dialog__body {
    background: rgba(243, 244, 247);
  }

  .w100 {
    width: 100%;
  }

  .h100 {
    height: 100%;
  }

  .flex {
    display: flex;
  }

  .centerContainer {
    width: 95%;
    margin: 0 auto;
  }

  .centerContainer1 {
    width: 95%;
    margin: 0 auto;
  }

  .bigBox {
    width: 100%;
    margin-top: 0px;
    position: absolute;
    /* left: -1%; */
    background: white;
    /* height: calc(100%); */
    height: 100%;
    z-index: 999;
    overflow: auto;
    overflow-x: hidden;
  }

  .bigBox::-webkit-scrollbar {
    display: none;
  }

  .hand {
    cursor: pointer;
  }

  .oneHidden {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }

  .twoHidden {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .threeHidden {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  ::-webkit-scrollbar {
    width: .06rem;
  }

  ::-webkit-scrollbar-track {
    background-color: rgba(24, 31, 41, 0.1);
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(24, 31, 41, 0.1);
    border-radius: .16rem;
  }

  .noData {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 10%;
    flex-wrap: wrap;
  }

  .noData .image {
    width: 2.27rem;
  }

  .noData .noDataZi {
    font-size: .14rem;
    color: #000;
    text-align: center;
  }

  .formcontent {
    height: 90%;
    margin-bottom: .5rem;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .formcontent::-webkit-scrollbar {
    display: none;
  }

  /* .el-popover{
    max-height: 400px;
    overflow-y: auto;
    overflow-x: hidden;
  } */
  .cropper .el-dialog__body {
    background-color: #fff !important;
    overflow: auto !important;
    overflow-x: hidden !important;
    max-height: 7rem !important;
    padding: .3rem .2rem !important;
    box-sizing: border-box;
  }

  .customstyle .el-dialog__body {
    background-color: #fff !important;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue